import React, { useEffect } from "react";
import { Box } from "@mui/material";
import DocProgress from "../../../components/cases/documents/DocProgress";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { getStatusQuoAutditTrail } from "../../../services/auditTrails";
import { useDispatch, useSelector } from "react-redux";
import { getUpdatedData } from "../../../redux/slices/DocumentsSlice";
const DocStatus = () => {
  const [data, handleRefresh, location] = useOutletContext();
  const currentTab = useSelector((state) => state.currentTab.currentTab);
  let dispatch = useDispatch();
  const { id } = useParams();
  const fetchAuditTrail = async () => {
    const result = await getStatusQuoAutditTrail(id);
    if (result?.success) {
      dispatch(getUpdatedData(result?.payLoad));
    } else {
      dispatch(getUpdatedData([]));
    }
  };
  useEffect(() => {
    fetchAuditTrail();
  }, [location, currentTab]);
  const path = location.pathname.split("/");
  return path[path?.length - 1] === "documents" ? (
    <Box component="div" className="doc-status">
      <DocProgress />
    </Box>
  ) : (
    <Outlet />
  );
};

export default DocStatus;
